module.exports = __webpack_public_path__ + "static/media/GT.b962a459.svg";